"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggingMessage = void 0;
const constants_1 = require("../../pro-api/constants");
var LoggingMessage;
(function (LoggingMessage) {
    LoggingMessage["EmptySourceCode"] = "Empty source code. Obfuscation canceled...";
    LoggingMessage["ObfuscationCompleted"] = "Obfuscation completed. Total time: %s sec.";
    LoggingMessage["ObfuscationStarted"] = "Obfuscation started...";
    LoggingMessage["RandomGeneratorSeed"] = "Random generator seed: %s...";
    LoggingMessage["CodeTransformationStage"] = "Code transformation stage: %s...";
    LoggingMessage["NodeTransformationStage"] = "AST transformation stage: %s...";
    LoggingMessage["Version"] = "Version: %s";
    LoggingMessage[LoggingMessage["JavaScriptObfuscatorProAdFirstPart"] = constants_1.proAdvertiseMessageFirstPart] = "JavaScriptObfuscatorProAdFirstPart";
    LoggingMessage[LoggingMessage["JavaScriptObfuscatorProAdSecondPart"] = constants_1.proAdvertiseMessageSecondPart] = "JavaScriptObfuscatorProAdSecondPart";
})(LoggingMessage || (exports.LoggingMessage = LoggingMessage = {}));
